var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home scroll-box"},[_c('discuss-tab',{attrs:{"postCategoryList":_vm.postCategoryList,"options":_vm.options},on:{"like":_vm.like}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }